import { Role } from '../../../../../shared/enums/role.enum';
import { SecondarySideMenuI } from '../../../../../shared/interfaces/secondary-side-menu.interface';

export const SIDE_MENU_ITEMS: SecondarySideMenuI[] = [
  {
    translationPath: 'sideMenu.courses',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: (programID: string) => `programs/${programID}/courses`,
    alt: 'Courses',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
  {
    translationPath: 'sideMenu.students',
    activeIcon: 'svgs/side-menu/active-student.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-student.svg',
    route: (programID: string) => `programs/${programID}/students`,
    alt: 'Students',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
];
